import { APIModel } from "../api-model";
import { AssociatedUser } from "../associated-user";
import { Tag } from "./tag";

export class AppliedTag extends APIModel {
  id!: string;
  match_id!: string;
  tag_id!: string;
  tag!: Tag;
  created_by!: AssociatedUser;

  static fieldsToMap = {
    direct: [
      'id',
      'match_id',
      'tag_id'
    ]
  }

  get label(): string {
    return `${this.tag?.tag_category?.category_name} (${this.tag?.tag_category?.category_identifier}) - ${this.tag?.name}`;
  }

  // Short label used in reports: "category_identifier-tag_name"
  get reportLabel(): string {
    return `${this.tag?.tag_category?.category_identifier}-${this.tag?.name}`;
  }

  static buildFromAPI(record: any): AppliedTag {
    const row = new AppliedTag();
    record = record || {};

    this.mapFieldsDirectly<AppliedTag>(AppliedTag.fieldsToMap.direct, record, row);

    row.tag = Tag.buildFromAPI(record.tag);
    row.created_by = AssociatedUser.buildFromAPI(record.created_by);

    return row;
  }
}